import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/contact/page.tsx");
